import type { NuxtAppManifestMeta } from "#app"

/**
 * Share app metadata globally. Can be used to notify users when new versions of the app are available.
 */
export function useAppMetadata() {
  return useState<NuxtAppManifestMeta | undefined>("app-metadata")
}
